import { LoanType } from '@qred/shared-enums';
import useTranslate from '../useTranslate';
import useOpenLink from './useOpenLink';

const useLoanLinks = (loanType: LoanType) => {
  const openExternalLink = useOpenLink();
  const t = useTranslate();

  const isAnnuityLoan = loanType === LoanType.ANNUITY_LOAN;

  const openGeneralTerms = () => {
    openExternalLink('LinkUrls.GeneralTerms', 'MissingLoanGeneralTermsUrl');
  };

  const openProductTerms = () => {
    const urlKey = isAnnuityLoan
      ? 'LinkUrls.InvestmentLoanTerms'
      : 'LinkUrls.FlexLoanTerms';
    openExternalLink(urlKey, 'MissingProductTermsUrl');
  };

  const openPriceList = () => {
    openExternalLink('LinkUrls.LoanPriceList', 'MissingLoanPriceListUrl');
  };

  const productTermsLinkText = isAnnuityLoan
    ? (t('OnboardingOffer.ProductTermsInvestmentLoanLinkText') as string)
    : (t('OnboardingOffer.ProductTermsFlexLoanLinkText') as string);

  return {
    openGeneralTerms,
    openProductTerms,
    openPriceList,
    productTermsLinkText,
  };
};

export default useLoanLinks;
